export default __webpack_public_path__ + "static/media/profile3.e5117e8e.jpg";